module.exports = __webpack_public_path__ + "static/media/Rosie Chen Headshot_1692186889167.70f240a6.jpeg";